let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3bCpl")).then(() => parcelRequire('7mPBC'));